module.exports = __webpack_public_path__ + "static/media/4d-result-white.133ecfe0.svg";